@if (jobs.length) {
  <div class="row mb-3">
    <div class="col-12">
      <message-box type="danger" title="Salesforce sync failed">
        @for (job of jobs; track job.correlationId) {
          <div class="mb-2 sync-failed-job">
            <div>
              <span>{{ job.jobType }}</span>
              @if (job.deadletteredAt) {
                <span> on {{ job.deadletteredAt | date: 'dd/MM/yyyy HH:mm' }}</span>
              }
              @if (job.lastError) {
                <span>: {{ job.lastError }}</span>
              }
            </div>
            @if (canRetry) {
              <button mat-flat-button class="mt-1" [disabled]="retrying" (click)="onRetry(job)">Retry</button>
            }
          </div>
        }
      </message-box>
    </div>
  </div>
}
